import { render, staticRenderFns } from "./certificateBox.vue?vue&type=template&id=5cf1f496&scoped=true&"
import script from "./certificateBox.vue?vue&type=script&lang=js&"
export * from "./certificateBox.vue?vue&type=script&lang=js&"
import style0 from "./certificateBox.vue?vue&type=style&index=0&id=5cf1f496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1f496",
  null
  
)

component.options.__file = "certificateBox.vue"
export default component.exports